import {
  employeeDetailService,
  IEmployeesRolesServiceResponse,
} from "../../../../Api/Services/EmployeeDetailsService/EmplooyeeDetailsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";

export const fetchEmployeeRolesThunk = createServiceAsyncThunk<
  IEmployeesRolesServiceResponse,
  void
>(
  ACTION_NAMES.FETCH_EMPLOYEE_TYPES,
  () => employeeDetailService.getEmployeeTypes(),
  ERROR_MESSAGES.FETCH_EMPLOYEES_TYPES_FAILURE
);

export const employeeTypesSlice = createGenericSlice<
  IEmployeesRolesServiceResponse,
  void
>(SLICE_NAMES.EMPLOYEE_TYPES_SLICE, fetchEmployeeRolesThunk);

export const {
  clearError: clearEmployeesTypeError,
  clearSuccessMessage: clearEmployeeTypeSuccess,
} = employeeTypesSlice.actions;

export default employeeTypesSlice.reducer;
